var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import "@frameworks/shared-library/stylesheets/components/GenericScrollToTopButton/GenericScrollToTopButton.scss";
var GenericScrollToTopButton = function (props) {
    var _a, _b, _c;
    var _d = props.showButtonAfterPixels, showButtonAfterPixels = _d === void 0 ? 200 : _d;
    var _e = __read(React.useState(false), 2), isShowButton = _e[0], setIsShowButton = _e[1];
    var handleScrollToTop = function () {
        if (props.scrollingElementRef) {
            props.scrollingElementRef.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    };
    React.useEffect(function () {
        if (props.scrollingElementRef) {
            var handleScroll_1 = function () {
                if (props.scrollingElementRef.scrollTop > showButtonAfterPixels) {
                    setIsShowButton(true);
                }
                else {
                    setIsShowButton(false);
                }
            };
            props.scrollingElementRef.addEventListener("scroll", handleScroll_1);
            return function () {
                props.scrollingElementRef.removeEventListener("scroll", handleScroll_1);
            };
        }
    }, [props === null || props === void 0 ? void 0 : props.scrollingElementRef, (_a = props === null || props === void 0 ? void 0 : props.scrollingElementRef) === null || _a === void 0 ? void 0 : _a.scrollTop]);
    return (React.createElement("div", { className: "".concat((_b = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _b !== void 0 ? _b : "", " primary-move-to-top-button-container hand_cursor ").concat(isShowButton ? "scroll-to-top-btn-visible" : "scroll-to-top-btn-hidden"), onClick: handleScrollToTop }, (_c = props === null || props === void 0 ? void 0 : props.customIcon) !== null && _c !== void 0 ? _c : React.createElement("i", { className: "edel-icon-arrow-up-thin" })));
};
export default GenericScrollToTopButton;
